import { DomainError } from "../errors/DomainError";

export type CountryCode = string;

export class InvalidCountryCodeError extends DomainError {
  constructor() {
    super("El código de país debe seguir el formato ISO 3166-1 alfa-2");
    this.name = "InvalidCountryCodeError";
  }
}

const COUNTRY_CODE_REGEX = /^[A-Z]{2,20}$/;

export const createCountryCode = (raw: string): CountryCode => {
  const normalized = raw.trim().toUpperCase();

  if (!COUNTRY_CODE_REGEX.test(normalized)) {
    throw new InvalidCountryCodeError();
  }

  return normalized;
};
